module.exports = {
  language: 'Français',
  applierApplicationCenter: {
    selectCenterTip: 'Sélectionnez ce centre'
  },
  multiplePage: {
    moreInfomation: "Plus d'informations",
    recommendedServices: 'Services Recommandés'
  },
  checkoutConfirm: {
    ordered: 'Commandé',
    purchased: 'Acheté'
  },
  personal: {
    purgePopupContent:
      'Désolé, votre demande a été effacée suivant nos conditions de sécurité, veuillez nous contacter si vous souhaitez déposer votre demande prochainement.'
  },
  login_maximum: {
    errorContent: "Désolé, vous avez atteint le nombre maximal de connexions aujourd'hui, veuillez essayer le lendemain."
  },
  nationalityKay: 'fr-fr',
  noneSelectedText: 'Veuillez sélectionner',
  multiselect: {
    deselect: 'Appuyez sur Entrée pour supprimer',
    select: 'Appuyez sur Entrée pour sélectionner',
    selected: 'Sélectionné'
  },
  enter: 'Entrez',
  upload_failed: 'Le téléchargement a échoué, veuillez réessayer',
  due_time: "Heure d'échéance",
  requirement: 'Exigence',
  something_went_wrong_please_retry: "Quelque chose s'est mal passé, veuillez réessayer.",
  valid_rediret_home_page_popup_content:
    'Une exception de connexion s\'est produite. Essayez-vous de vous rendre sur la page d\'accueil de [ {country} - {center} ] pour vous connecter ? Si oui, veuillez cliquer sur "Confirmer" ; si non, veuillez cliquer sur "Annuler" pour sélectionner à nouveau.',
  invalid_rediret_home_page_popup_content:
    "Une exception de connexion s'est produite, veuillez sélectionner le pays et la localisation pour continuer.",
  'Temporarily not available': 'Temporairement indisponible',
  'Coming soon': 'Bientôt disponible'
};
